import {match} from 'ts-pattern';

import {InspectionState, InspectionStateLiteral} from '@dms/api/core';

export function getNextPossibleInspectionState(
  currentState: InspectionStateLiteral
): InspectionState[] {
  return match(currentState)
    .with(InspectionState.FOR_CHECK, () => [InspectionState.IN_PROGRESS])
    .with(InspectionState.IN_PROGRESS, () => [
      InspectionState.TO_REVISION,
      InspectionState.FINISHED_AUDIT,
    ])
    .with(InspectionState.TO_REVISION, () => [InspectionState.IN_REVISION])
    .with(InspectionState.IN_REVISION, () => [
      InspectionState.TO_FINISHING,
      InspectionState.FINISHED_AUDIT,
    ])
    .with(InspectionState.TO_FINISHING, () => [InspectionState.TO_REVISION])
    .with(InspectionState.FINISHED_AUDIT, () => [InspectionState.IN_PROGRESS])
    .otherwise(() => []);
}
